export default "__VITE_ASSET__0ea29f64__"